import {
  IAuthStorageRepository,
  IUserStorageRepository,
} from "@/domain/repositories/storage.repository";
import { LocalStorage } from "@/infrastructure/storage/local.storage";

enum KEYS {
  ACCESS_TOKEN = "accessToken",
  REFRESH_TOKEN = "refreshToken",
  EMAIL = "user_email",
}

const AuthStorageRepository: IAuthStorageRepository = {
  setAccessToken: (token: string) => LocalStorage.set(KEYS.ACCESS_TOKEN, token),
  getAccessToken: () => LocalStorage.get(KEYS.ACCESS_TOKEN),
  setRefreshToken: (token: string) =>
    LocalStorage.set(KEYS.REFRESH_TOKEN, token),
  getRefreshToken: () => LocalStorage.get(KEYS.REFRESH_TOKEN),
  clear: () => {
    Object.values(KEYS).forEach((key) => LocalStorage.remove(key));
  },
  clearTokens() {
    LocalStorage.remove(KEYS.ACCESS_TOKEN);
    LocalStorage.remove(KEYS.REFRESH_TOKEN);
  },
};

const UserStorageRepository: IUserStorageRepository = {
  setEmail: (email: string) => LocalStorage.set(KEYS.EMAIL, email),
  getEmail: () => LocalStorage.get(KEYS.EMAIL),
  clear: () => LocalStorage.remove(KEYS.EMAIL),
};

export { AuthStorageRepository, UserStorageRepository };
